import { Component, Input, OnInit } from '@angular/core';
import { RowAction } from 'src/app/core/interfaces/row-action.interface';
import { PermissionService } from 'src/app/core/services/permission.service';

@Component({
  selector: 'app-table-row-actions-v1',
  templateUrl: './table-row-actions.component.html',
  styleUrl: './table-row-actions.component.scss'
})
export class TableRowActionsComponent implements OnInit {
  @Input({ required: true }) actions!: RowAction[];

  @Input({ required: true }) item: any;

  allowActions: RowAction[] = [];

  ngOnInit() {
    this.allowActions = this.actions.filter(action => this.isAllowed(action.premission));
  }

  private isAllowed(permission?: string): boolean {
    if (!permission) return true;
    else {
      return this.perm.hasPermission(permission);
    }
  }

  constructor(private perm: PermissionService) { }
}
